import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MiniGamePage.css';
import { useAuth } from '../contexts/AuthContext';
import { BaseLayout, MiniGameCard } from '../components';
import { GameConfigService, GameConfig } from '../services/gameConfigService';

const MiniGamePage: React.FC = () => {
  const navigate = useNavigate();
  const [gameConfig, setGameConfig] = useState<GameConfig | null>(null);
  const [loading, setLoading] = useState(true);

  // Load game configuration on component mount
  useEffect(() => {
    const loadGameConfig = async () => {
      try {
        setLoading(true);
        const config = await GameConfigService.getGameConfig();
        setGameConfig(config);
      } catch (error) {
        console.error('Failed to load game config:', error);
      } finally {
        setLoading(false);
      }
    };

    loadGameConfig();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleMiniQuizPlay = () => {
    navigate('/mini-quiz'); // Temporary test page
  };

  const handleKilobaRacePlay = () => {
    navigate('/kiloba-racing');
  };

  const handleKiloba9CloudsPlay = () => {
    navigate('/cloud-tower-game');
  };

  // Show loading state while fetching config
  if (loading) {
    return (
      <div className="mini-game-page">
        <button className="mini-game-back-btn" onClick={handleBackClick}>
          <img src="/images/icons/back.svg" alt="Back" />
        </button>
        <div className="mini-game-title">
          <span>Mini-Game</span>
        </div>
        <div className="mini-game-content">
          <div className="loading">Đang tải...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="viewport-wrapper">
      <BaseLayout className="common-container" backgroundColor="transparent">
        <div className="mini-game-page">
          <button className="mini-game-back-btn" onClick={handleBackClick}>
            <img src="/images/icons/back.svg" alt="Back" />
          </button>
          <div className="mini-game-title">
            <span>Mini-Game</span>
          </div>
          <div className="mini-game-content">
            <div className="mini-game-list">
              <MiniGameCard
                title="Miniquiz"
                description="Trả lời các câu hỏi thú vị về KILOBA và nhận phần thưởng hấp dẫn!"
                rewardAmount={gameConfig?.quiz?.energyReward || 5}
                gameType="quiz"
                onPlayClick={handleMiniQuizPlay}
                isAvailable={true}
              />
              
              <MiniGameCard
                title="KILOBA Đi Đua"
                description="Điều khiển KILOBA của bạn tham gia cuộc đua gay cấn và giành chiến thắng!"
                rewardAmount={gameConfig?.racing?.energyReward || 5}
                gameType="didua"
                onPlayClick={handleKilobaRacePlay}
                isAvailable={gameConfig ? GameConfigService.canPlayGame(gameConfig, 'racing') : true}
              />
              
              <MiniGameCard
                title="KILOBA 9 Tầng Mây"
                description="Giúp KILOBA vượt qua 9 tầng mây để đến được thiên đường và nhận thưởng lớn!"
                rewardAmount={gameConfig?.clouds?.energyReward || 5}
                gameType="9tangmay"
                onPlayClick={handleKiloba9CloudsPlay}
                isAvailable={gameConfig ? GameConfigService.canPlayGame(gameConfig, 'clouds') : true}
              />
            </div>
          </div>
        </div>
      </BaseLayout>
    </div>
  );
};

export default MiniGamePage;
